<template>
    <div>
        <slot>
            <label
                v-if="title"
                :for="name"
            >
                {{ title }}
            </label>
            <textarea
                :name="name"
                class="form-control wysiwyg-textarea"
            >
                {{ content }}
            </textarea>
        </slot>
    </div>
</template>

<script>
  import tinymce from 'tinymce';
  import autoresize from 'tinymce/plugins/autoresize';
  import lists from 'tinymce/plugins/lists';
  import code from 'tinymce/plugins/code';
  import paste from 'tinymce/plugins/paste';

  export default {
    props: {
      content: {default: ''},
      title: {default: false},
      name: {required: true},
      bodyClass: {
        default: 'vegas'
      }
    },
    data() {
      return {
        activeTab: 'edit'
      }
    },
    mounted() {
      tinymce.init({
        selector: '.wysiwyg-textarea',
        menubar: false,
        statusbar: true,
        toolbar: 'bold italic | bullist numlist | styleselect | undo redo | removeformat code |',
        plugins: "lists autoresize code paste",
        autoresize_bottom_margin: 20,
        theme_url:
          'https://cdnjs.cloudflare.com/ajax/libs/tinymce/4.8.5/themes/modern/theme.min.js',
        skin_url:
          'https://cdnjs.cloudflare.com/ajax/libs/tinymce/4.8.5/skins/lightgray',
        content_css: [
          '//fonts.googleapis.com/css?family=Open+Sans:400,300,600,700',
          '/css/lauren.css'
        ],
        body_class: this.bodyClass
      });
    },
    watch: {
      content(value) {
        tinymce.activeEditor.setContent(value)
      }
    }
  }
</script>
